import http from "../http-common";

class ProductDataService {
    getAll() {
        return http.get('/products');
    }

    get(id) {
        return http.get(`/products/${id}`);
    }

    create(data) {
        const formData = new FormData();
        formData.append('name', data.name);
        // Ensure price is sent as a number (FormData will convert to string, but Laravel accepts it)
        formData.append('price', parseFloat(data.price) || 0);
        // Append tracking if provided
        if (data.tracking) {
            formData.append('tracking', data.tracking);
        }
        // Only append image if it's actually a file (not null)
        if (data.image && data.image instanceof File) {
            formData.append('image', data.image);
        }
        return http.post('/products', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    update(id, data) {
        const formData = new FormData();
        formData.append('_method', 'PUT'); // Laravel method spoofing for multipart/form-data
        formData.append('name', data.name || '');
        // Ensure price is sent as a number (FormData will convert to string, but Laravel accepts it)
        const priceValue = parseFloat(data.price);
        formData.append('price', isNaN(priceValue) ? 0 : priceValue);
        // Append tracking if provided
        if (data.tracking) {
            formData.append('tracking', data.tracking);
        }
        // Only append image if it's actually a file (not null)
        if (data.image && data.image instanceof File) {
            formData.append('image', data.image);
        }
        // Use POST with _method=PUT for multipart/form-data (Laravel best practice)
        return http.post(`/products/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    delete(id) {
        return http.delete(`/products/${id}`);
    }
}

export default new ProductDataService();
